<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-router-outlet id="main-content" [swipeGesture]="false"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
